<template>
  <div class="d-flex justify-space-between">
    <BaseDataV2
      :value="apport.numeroBon"
      is-secondaire
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
    />

    <BaseDataV2
      :value="apport.poidsNetEnKg | roundNumber(3, 0.001)"
      is-principal
      unit="t"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
    />

    <BaseDataV2
      :value="apport.poidsAuxNormesEnKg | roundNumber(3, 0.001)"
      is-principal
      unit="t"
      message="Aucune donnée"
      custom-class="intro"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.poidsSpecifiqueEnKgParHectolitre)"
      :value="apport.caracteristiques.poidsSpecifiqueEnKgParHectolitre"
      unit="kg/hl"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      :value="apport.caracteristiques.humiditeTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      :value="apport.caracteristiques.impureteTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.proteineTaux)"
      :value="apport.caracteristiques.proteineTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.tempsChuteHacbergEnSeconde)"
      :value="apport.caracteristiques.tempsChuteHacbergEnSeconde"
      unit="s"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.echaudeBriseTaux)"
      :value="apport.caracteristiques.echaudeBriseTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.germeMitadineFusarieTaux)"
      :value="apport.caracteristiques.germeMitadineFusarieTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.impureteGrainTaux)"
      cols="6"
      :value="apport.caracteristiques.impureteGrainTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.mitadineTaux)"
      :value="apport.caracteristiques.mitadineTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.zelenyIndiceEnMillilitre)"
      :value="apport.caracteristiques.zelenyIndiceEnMillilitre"
      unit="mL"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainBrucheTaux)"
      :value="apport.caracteristiques.grainBrucheTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainCasseTaux)"
      :value="apport.caracteristiques.grainCasseTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.grainGermeTaux) && apport.caracteristiques.grainGermeTaux != null) || isApportsContainsGrainGermeTaux"
      :value="apport.caracteristiques.grainGermeTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.flairAnormal) && apport.caracteristiques.flairAnormal === true) || isApportsContainsFlairAnormal"
      :value="apport.caracteristiques.flairAnormal === true ? 'Oui': 'Non'"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.insectePresent) && apport.caracteristiques.insectePresent === true) || isApportsContainsInsectePresent"
      :value="apport.caracteristiques.insectePresent === true ? 'Oui': 'Non'"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.matiereGrasseTaux) && apport.caracteristiques.matiereGrasseTaux != null) || isApportsContainsMatiereGrasseTaux"
      :value="apport.caracteristiques.matiereGrasseTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.omega3Taux) && apport.caracteristiques.omega3Taux != null) || isApportsContainsOmega3Taux"
      :value="apport.caracteristiques.omega3Taux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.daturaPresent) && apport.caracteristiques.daturaPresent === true) || isApportsContainsDaturaPresent"
      value="Oui"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.ergotPresent) && apport.caracteristiques.ergotPresent === true) || isApportsContainsErgotPresent"
      value="Oui"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
    />

    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.calibrageTaux) && apport.caracteristiques.calibrageTaux != null) || isApportsContainsCalibrageTaux"
      :value="apport.caracteristiques.calibrageTaux"
      unit="%"
      message="Aucune donnée"
      class="mb-2 mb-md-0"
      custom-class="intro"
      :precision="1"
    />

    <BaseDataV2
      :value="apport.siloDestination.libelle"
      class="mb-2 mb-md-0"
      custom-class="intro"
      message="Aucune donnée"
    />
    <div
      v-if="!$vuetify.breakpoint.mobile"
      class="w-140 text-center"
    >
      <div
        v-if="!apport.sansContrat"
        class="d-flex"
      >
        <v-btn
          class="white primary--text pa-0"
          outlined
          @click="openDetailModal()"
        >
          <v-icon>mdi-information-outline</v-icon>
          <span class="texte primary--text">Détails</span>
        </v-btn>
      </div>
      <div
        v-else
        class="d-flex"
      >
        <span class="texte primary--text"> - </span>
      </div>
    </div>

    <DetailApportModal
      v-if="isOpenModalDetailApport"
      :apport="apport"
      :is-open-modal-detail-apport="isOpenModalDetailApport"
      :loading-detail-mouvement="loadingDetailMouvement"
      :erreur-detail-mouvement="erreurDetailMouvement"
      @close="isOpenModalDetailApport = false"
    />
  </div>
</template>

<script>
import caracteristiques from '@/model/caracteristiquesGraines'
import BaseDataV2 from '@/components/common/base-data-v2.vue'
import DetailApportModal from './modal/detail-apport-modal.vue'
import {mapActions} from 'vuex'

export default {
  name: 'DetailApport',
  components: { BaseDataV2, DetailApportModal },
  props: {
    apport: {
      type: Object,
      default: () => { }
    },
    graineRs3: {
      type: Object,
      required: true
    },
    apports: {
      type: Array,
      default: null
    },
  },

  data () {
    return {
      caracteristiques,
      isOpenModalDetailApport: false,
      loadingDetailMouvement: false,
      erreurDetailMouvement: false
    }
  },

  computed: {
     isApportsContainsGrainGermeTaux () {
      return this.apports.findIndex(apport => apport.caracteristiques.grainGermeTaux && apport.caracteristiques.grainGermeTaux != null) !== -1
    },
    isApportsContainsFlairAnormal () {
      return this.apports.findIndex(apport => apport.caracteristiques.flairAnormal && apport.caracteristiques.flairAnormal === true) !== -1
    },
    isApportsContainsInsectePresent () {
      return this.apports.findIndex(apport => apport.caracteristiques.insectePresent && apport.caracteristiques.insectePresent === true) !== -1
    },
    isApportsContainsMatiereGrasseTaux () {
      return this.apports.findIndex(apport => apport.caracteristiques.matiereGrasseTaux && apport.caracteristiques.matiereGrasseTaux != null) !== -1
    },
    isApportsContainsOmega3Taux () {
      return this.apports.findIndex(apport => apport.caracteristiques.omega3Taux && apport.caracteristiques.omega3Taux != null) !== -1
    },
    isApportsContainsDaturaPresent () {
      return this.apports.findIndex(apport => apport.caracteristiques.daturaPresent && apport.caracteristiques.daturaPresent === true) !== -1
    },
    isApportsContainsErgotPresent () {
      return this.apports.findIndex(apport => apport.caracteristiques.ergotPresent && apport.caracteristiques.ergotPresent === true) !== -1
    },
    isApportsContainsCalibrageTaux () {
      return this.apports.findIndex(apport => apport.caracteristiques.calibrageTaux && apport.caracteristiques.calibrageTaux != null) !== -1
    },
    buildIcon () {
      const icon = {
        display: true,
        name: 'mdi-information-outline',
        couleur:'primary--text'
      }
      return icon
    }
  },
  methods: {
    ...mapActions({
      getDetailMouvement: 'mouvement/getDetailMouvement'

    }),
    openDetailModal () {
      this.isOpenModalDetailApport = true
      this.loadDetailMouvement()
    },
    loadDetailMouvement () {
      this.loadingDetailMouvement = true
      this.erreurDetailMouvement = false

      const params = {
        numeroBon: this.apport.numeroBon,
        numeroContrat: this.apport.numeroContratCommercial
      }

      this.getDetailMouvement(params)
        .catch(() => {
          this.erreurDetailMouvement = true
        })
        .finally(() => this.loadingDetailMouvement = false)

    },
  }
}
</script>

<style  lang="scss" scoped>
.w-140 {
  width: 140px;
}
</style>